<template>
  <label class="app-ck-bk">
    <input type="checkbox" v-model="model" />
    <slot></slot>
  </label>
</template>

<script setup lang="ts">
const model = defineModel<boolean>({ default: false });
</script>

<style lang="scss" scoped></style>
